export default __webpack_public_path__ + "static/media/comic2_Panel2.0aa23740.png";